import React, { Fragment, Component } from 'react';
import { Form } from 'react-final-form';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { loadBanks, setZwalletTransfer } from '../actions';
import { FormBody } from './Form';
import Header from './Header';


class ZwalletTransfer extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(loadBanks());
  }

  submit(data) {
    const { dispatch } = this.props;
    dispatch(setZwalletTransfer(data));
  }

  render() {
    if (this.props.redirect) {
      return <Redirect to="/zwallet" />
    }

    return (
      <Fragment>
        <Header />
        <div className="container-fluid mt--6">
          <div className="row">
            <div className="col">
              <div className="card">
                <div className="card-header">
                  <div className="row align-items-center">
                    <div className="col-12">
                      <h3 className="mb-0">
                        Formulário de Transferência
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <Form
                      onSubmit={(data) => this.submit(data)}
                      render={(props) => (
                          <FormBody banks={this.props.banks} {...props} />
                      )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
    const { zwallet } = state;
    const { banks, redirect } = zwallet.transfer;

    return { banks, redirect }
}

export default connect(mapStateToProps)(ZwalletTransfer);


// WEBPACK FOOTER //
// ./src/ZWallet/Transfer/components/Transfer.js